// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--nj0VA","files":"files--QFMk9","delimiter":"delimiter--u3n9U","label":"label--hYzZP","title":"title--MBsMk"};